import { render, staticRenderFns } from "./AddSelfMedicationModal.vue?vue&type=template&id=a9454832&scoped=true"
import script from "./AddSelfMedicationModal.vue?vue&type=script&lang=js"
export * from "./AddSelfMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9454832",
  null
  
)

export default component.exports